export class HistoryManager {
  constructor(maxStates = 50) {
    this.undoStack = []
    this.redoStack = []
    this.maxStates = maxStates
  }

  saveState(design) {
    this.undoStack.push(JSON.stringify(design))
    this.redoStack = []
    if (this.undoStack.length > this.maxStates) {
      this.undoStack.shift()
    }
  }

  undo(currentDesign) {
    if (this.undoStack.length === 0) return null
    this.redoStack.push(JSON.stringify(currentDesign))
    return JSON.parse(this.undoStack.pop())
  }

  redo(currentDesign) {
    if (this.redoStack.length === 0) return null
    this.undoStack.push(JSON.stringify(currentDesign))
    return JSON.parse(this.redoStack.pop())
  }

  canUndo() {
    return this.undoStack.length > 0
  }

  canRedo() {
    return this.redoStack.length > 0
  }

  clear() {
    this.undoStack = []
    this.redoStack = []
  }
}
